/*
 * Copyright (c) 2022
 * This file is part of the Compo B2B application.
 * Compo soft - Grigory Miroshnichenko <grinderspro@gmail.com>
 * For the full copyright and license information, please view
 * the LICENSE file that was distributed with this source code.
 */

export interface Faq {
  id: number;
  header: string;
  content: string;
  groupId: number;
  groupHeader: string;
}
